/* GoldenLove — Peek button press behaviour.

   Hover and focus are pure CSS. This file exists for one reason: the press.

   `:active` is no good for a link. The moment the pointer lifts, navigation
   starts and the state is gone, so nobody ever sees the bark. Instead the pop
   is driven by a class added on pointerdown, and for links the navigation is
   held back very briefly so the animation is actually visible.

   The delay is deliberately small and is skipped whenever it would be wrong:
   reduced motion, modifier-clicks, middle-clicks, and anything opening in a
   new tab. A visitor must never feel the site is slow to respond.
*/

(function () {
  'use strict';

  var WOOF = 620;       // ms the pop is held
  var HOLD_NAV = 300;   // ms navigation is delayed so the bark is seen

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bark(wrap) {
    wrap.classList.add('is-woofing');
    if (wrap.__woofTimer) clearTimeout(wrap.__woofTimer);
    wrap.__woofTimer = setTimeout(function () {
      wrap.classList.remove('is-woofing');
      wrap.__woofTimer = null;
    }, WOOF);
  }

  function init() {
    var wraps = document.querySelectorAll('[data-peek]');
    if (!wraps.length) return;

    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.__wired) return;
      wrap.__wired = true;

      var control = wrap.querySelector('.voffen-peekbtn');
      if (!control) return;

      // pointerdown, not click: the pop starts the instant the press begins,
      // so it has already played by the time the pointer lifts.
      control.addEventListener('pointerdown', function (event) {
        if (event.button !== 0) return;
        if (reduced.matches) return;
        bark(wrap);
      });

      // Keyboard activation never fires pointerdown.
      control.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (reduced.matches) return;
        bark(wrap);
      });

      var href = control.getAttribute('href');
      if (!href) return;

      control.addEventListener('click', function (event) {
        if (reduced.matches) return;
        if (event.defaultPrevented) return;

        // Leave every "open somewhere else" gesture completely alone.
        if (
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          control.target === '_blank'
        ) {
          return;
        }

        event.preventDefault();
        bark(wrap);

        setTimeout(function () {
          window.location.href = href;
        }, HOLD_NAV);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
